// Mirrors the existing soft-delete contract without removing the post's ID,
// position, author, votes or any replies from the current page.
export function reconcileForumDeletion(model, result) {
  if (!model || model.thread.id !== result.threadId) return model;
  const marker = '[Este mensaje ha sido eliminado]';
  return { ...model, posts: model.posts.map(post => {
    if (post.id === result.postId && post.type === result.postType) return { ...post, deleted: true, html: '<p>' + marker + '</p>', attachments: [], quote: null, quoteUnavailable: false };
    if (result.postType === 'comment' && post.quote && post.quote.id === result.postId) return { ...post, quote: { ...post.quote, excerpt: marker } };
    return post;
  }) };
}
